export type AgencyId = 'mosgortur' | 'leveltravel';

export interface AgencyConfig {
  id: AgencyId;
  name: string;
  hostname: string;
}

export const MOSGORTUR_AGENCY: AgencyConfig = {
  id: 'mosgortur',
  name: 'Мосгортур',
  hostname: 'russia.mosgortur.ru',
};

export const LEVEL_TRAVEL_AGENCY: AgencyConfig = {
  id: 'leveltravel',
  name: 'Level Travel',
  hostname: 'level.travel',
};

const AGENCIES_BY_HOSTNAME: Record<string, AgencyConfig> = {
  [MOSGORTUR_AGENCY.hostname]: MOSGORTUR_AGENCY,
  [LEVEL_TRAVEL_AGENCY.hostname]: LEVEL_TRAVEL_AGENCY,
};

export const resolveAgencyByHostname = (
  hostname: string,
): AgencyConfig | null =>
  AGENCIES_BY_HOSTNAME[hostname.trim().toLowerCase()] || null;

export const getCurrentAgency = (): AgencyConfig | null =>
  resolveAgencyByHostname(
    typeof window === 'undefined' ? '' : window.location.hostname,
  );
